import { buildUrl } from './Utils'

/* -------------------------------------------------------------------------- */
/*                              PUBLIC GET ASSET                              */
/* -------------------------------------------------------------------------- */

export const PUBLICASSETS = (assetId?: string): string => {
  return buildUrl(`/api/public/assets/${assetId ? `${assetId}/` : ''}`)
}

export const PUBLICASSETS_BY_URL_ID = (id?: string, _?: 'url_id' | 'id'): string => {
  const url = `/api/public/assets/${id}/`
  return buildUrl(url)
}

/* -------------------------------------------------------------------------- */
/*                         PUBLIC ASSET QUALIFICATION                         */
/* -------------------------------------------------------------------------- */

export const QUALIFICATION_PUBLIC = (assetId: string): string => {
  return buildUrl(`/api/public/assets/${assetId}/qualification/`)
}
